import arrowUpIcon from "../../../../assets/images/icons/arrow-up.png"
import {useEffect, useState} from "react";
import {eventTag, truncateText} from "../../../../services/utils";
import './index.scss'

const StepsNavigation = ({data, isDisabled = false, lastStepSaved = 1, currentStep, setCurrentStep, event, children}) => {
  const [open, setOpen] = useState(false)
  const [steps, setSteps] = useState([])

  const changeStep = (step) => {
    if (isDisabled) return false;

    if (step.id !== currentStep && step.id <= lastStepSaved) {
      setCurrentStep(step.id)
    }
    setOpen(false)
    eventTag(event?.name, "menu", event?.action, step?.title)
  }

  useEffect(()=>{
    const list = data.map(item => {
      return {
        id: item.index,
        title: item.title,
        subtitle: item.subtitle,
        status: item.isCompleted ? 'completed' : 'incomplete',
      }
    })
    setSteps(list)
  }, [data])

  return (
    <nav className="steps-navigation">
      {children}
      <ul className={"steps-navigation__sections "+(open ? 'open' : '')+(currentStep === 1 ? ' first-step' : '')}>
        {
          steps?.map(item => (
            <li key={item.id}
                onClick={() => changeStep(item)}
                className={(item.id === 1 ? "steps-navigation__name " : "") + (item.id <= lastStepSaved ? item.status : "") + (item.id === currentStep ? " current" : "")}>
              <p className="steps-navigation__sections__text mobile" title={item.title}>{item.id === 1 ? truncateText(item?.title, 40) : item.title}</p>
              <p className="steps-navigation__sections__text desktop" title={item.title}>{item.id === 1 ? truncateText(item?.title, 22) : item.title}</p>
              <div className="steps-navigation__sections__icon">
                {
                  item.id <= lastStepSaved ? item.status === "completed" ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM12.72 6.79L8.43 11.09L6.78 9.44C6.53561 9.15462 6.15188 9.03032 5.78658 9.11819C5.42128 9.20606 5.13606 9.49128 5.04819 9.85658C4.96032 10.2219 5.08462 10.6056 5.37 10.85L7.72 13.21C7.90872 13.3972 8.1642 13.5015 8.43 13.5C8.69234 13.4989 8.94374 13.3947 9.13 13.21L14.13 8.21C14.3193 8.02223 14.4258 7.76664 14.4258 7.5C14.4258 7.23336 14.3193 6.97777 14.13 6.79C13.74 6.40228 13.11 6.40228 12.72 6.79ZM2 10C2 14.4183 5.58172 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10Z" fill="white"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M11.9996 17.0559H12.0088M11.9996 10.2946V13.6753M10.3629 4.90478L2.25626 18.1828C2.08923 18.4668 2.00089 18.7888 2.00001 19.1167C1.99913 19.4446 2.08575 19.767 2.25125 20.0519C2.41675 20.3367 2.65537 20.5741 2.94339 20.7405C3.2314 20.9068 3.55878 20.9963 3.89297 21H20.1062C20.4405 20.9966 20.7681 20.9074 21.0563 20.7411C21.3445 20.5748 21.5833 20.3374 21.7489 20.0524C21.9145 19.7674 22.001 19.4448 22 19.1168C21.9989 18.7888 21.9103 18.4668 21.7429 18.1828L13.6374 4.90478C13.467 4.62861 13.2268 4.40025 12.9401 4.24176C12.6533 4.08327 12.3298 4 12.0007 4C11.6716 4 11.3481 4.08327 11.0614 4.24176C10.7747 4.40025 10.5345 4.62861 10.364 4.90478" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : ""
                }
              </div>
              {
                item.id === 1 ? (
                  <img className={open ? "open" : ""}
                       src={arrowUpIcon} alt="arrow"
                       onClick={(e) => {
                         e.stopPropagation()
                         setOpen(!open)
                       }} />
                ) : ""
              }
            </li>
          ))
        }
      </ul>
    </nav>
  )
}

export default StepsNavigation